"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyNav = void 0;
var react_1 = require("react");
var useKeyNav = function (id, focusedIndex, onChange, handleFocusChange, totalOptions, index) {
    var containerRef = (0, react_1.useRef)(null);
    var isFirstRender = (0, react_1.useRef)(true);
    (0, react_1.useEffect)(function () {
        var _a;
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        if (focusedIndex === index) {
            (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [focusedIndex, index]);
    var handleArrowKey = (0, react_1.useCallback)(function (event) {
        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
            event.preventDefault();
            handleFocusChange(focusedIndex < totalOptions - 1 ? focusedIndex + 1 : 0);
        }
        else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
            event.preventDefault();
            handleFocusChange(focusedIndex > 0 ? focusedIndex - 1 : totalOptions - 1);
        }
        else if (event.key === ' ') {
            event.preventDefault();
            onChange(id);
        }
    }, [focusedIndex, totalOptions, handleFocusChange, onChange, id]);
    return {
        handleArrowKey: handleArrowKey,
        containerRef: containerRef,
    };
};
exports.useKeyNav = useKeyNav;
